module.exports = __webpack_public_path__ + "static/media/kingspan.75c603a5.png";